module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/minus-d9d53f846146f239c7600c69fe9a7f03.svg";